import { useLightMode } from '@/hooks/useLightMode'
import { useTranslation } from 'react-i18next'

import { Modal as DarkModal } from '@hivewatch/dark'

import { CreateCaseForm } from './CreateCaseForm'

interface DarkCreateCaseModalIProps {
  isOpen: boolean
  onClose: () => void
}

/**
 * Rebrand variant of {@link CreateCaseModal} built on the dark `Modal`.
 * `CreateCaseForm` already ships a rebrand branch with its own MultiPartForm
 * footer, so the modal hides its Save button and delegates submission — the
 * same composition the incident drawer's dark AssociateCaseModal uses.
 */
export const DarkCreateCaseModal = ({
  isOpen,
  onClose,
}: DarkCreateCaseModalIProps) => {
  const { t } = useTranslation()
  const colorScheme = useLightMode()

  return (
    <DarkModal
      bodyStyleOverrides={{ pb: '24px' }}
      colorScheme={colorScheme}
      isOpen={isOpen}
      isSaveHidden
      onClose={onClose}
      size='large'
      title={t('cases:crud_create_case_modal_title')}
    >
      <CreateCaseForm colorScheme={colorScheme} isRebrand onClose={onClose} />
    </DarkModal>
  )
}
